'use client'

import { cn } from '@/lib/utils'
import { PortableText } from 'next-sanity'
import Link from 'next/link'
import { useState } from 'react'

export default function Accordion({ accordion }) {
	return (
		<div className={`site-grid my-[8rem] md:my-[10rem]`}>
			<div
				className={`col-span-full sm:col-span-10 md:col-span-8 sm:col-start-2 md:col-start-3 grid grid-cols-1 gap-y-8`}>
				{accordion?.map((item, index) => <AccordionItem key={`item-${item?.heading}`} {...item} />)}
			</div>
		</div>
	)
}

function AccordionItem({ heading, text }) {
	const [isOpen, setIsOpen] = useState(false)
	const richTextComponents = {
		block: {
			h2: ({ children }: any) => (
				<h2 className="style-body--xl md:text-center mt-[4rem] md:mt-[6rem] mb-[3rem] md:mb-[5rem]">{children}</h2>
			),
			normal: ({ children }: any) => <p className="style-body--lg mb-6">{children}</p>,
			blockquote: ({ children }: any) => <blockquote className="blockquote">{children}</blockquote>
		},
		marks: {
			link: ({ children, value }: any) => {
				const target = !value?.url?.startsWith('/') ? '_blank' : '_self'
				const rel = !value?.url?.startsWith('/') ? 'noreferrer noopener' : ''
				return target === '_blank' ? (
					<a href={value?.url} className="text-current hover:text-blue" rel={rel} target={target}>
						{children}
					</a>
				) : (
					<Link href={value?.url} className="text-current hover:text-blue" rel={rel} target={target}>
						{children}
					</Link>
				)
			}
		}
	}

	return (
		<div key={`column-${heading}`} className={`grid grid-cols-1`}>
			<h3
				className="accordion-heading relative style-body--xl sm:style-body--xl md:style-h2 pl-12 sm:pl-[10%] md:pl-[12.5%] cursor-pointer"
				onClick={() => setIsOpen((prevState) => !prevState)}>
				<span className={`absolute top-[-0.1em] left-0 ${isOpen ? `rotate-90` : `rotate-0`} transition`}>
					<svg className="w-7 md:w-14 h-auto" viewBox="0 0 48 30" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M47.9259 14.8764C41.3662 11.3437 35.1171 6.34087 30.4391 0.898868C30.3459 0.790127 30.1686 0.874862 30.1934 1.01538C31.4382 8.23961 33.8468 12.3817 35.0479 14.082H0.141222C0.0635501 14.082 0 14.1455 0 14.2232V15.7767C0 15.8543 0.0635501 15.9179 0.141222 15.9179H35.0472C33.8461 17.6182 31.4375 21.7602 30.1926 28.9845C30.1686 29.1257 30.3452 29.2097 30.4384 29.101C35.1164 23.659 41.3655 18.6562 47.9252 15.1235C48.0248 15.0705 48.0248 14.9293 47.9259 14.8764Z"
							fill="currentColor"
						/>
					</svg>
				</span>

				<span className="">{heading}</span>
			</h3>

			<div
				className={cn('w-full sm:w-auto grid transition-all duration-300', {
					'grid-rows-[1fr]': isOpen,
					'grid-rows-[0fr]': !isOpen
				})}>
				<div className="overflow-hidden">
					<div className="style-body style-body pl-12 sm:pl-[10%] md:pl-[12.5%] mt-8">
						<PortableText value={text} components={richTextComponents} />
					</div>
				</div>
			</div>
		</div>
	)
}
